function debounce(fn, t = 100) {
  let time = null
  return function() {
    if (time != null) {
      clearTimeout(time)
    }
    time = setTimeout(fn.bind(this, ...arguments), t)
  }
}
export default debounce
